import { z } from 'zod'
import {
  sanitizeBrowserIdentifier,
  sanitizeBrowserText,
} from '~/utils/security/sanitizeBrowserInput'

const SanitizedDestinationSearchSchema = z
  .string()
  .transform((value) => sanitizeBrowserText(value, 160))
  .refine((value) => value.length > 0, 'Destination search must not be empty')

const SanitizedDestinationIdentifierSchema = z
  .string()
  .transform((value) => sanitizeBrowserIdentifier(value, 64))
  .refine((value) => value.length > 0, 'Destination field must not be empty')

export const DestinationParamsSchema = z.object({
  dest_search: SanitizedDestinationSearchSchema,
  dest_id: SanitizedDestinationIdentifierSchema,
  dest_type: SanitizedDestinationIdentifierSchema,
})

export const DateRangeParamsSchema = z.object({
  startDateTime: z.string().optional(),
  endDateTime: z.string().optional(),
})

export const PaginationParamsSchema = z.object({
  page: z.coerce.number().optional().default(1),
  scrollRef: z.string().optional(),
})

export const SortingParamsSchema = z.object({
  sortBy: z.string().optional(),
  orderBy: z.string().optional(),
})
